(function () {
  const STORAGE_KEY = 'ssw_favourites';

  function getFavourites() {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      return [];
    }
  }

  function saveFavourites(items) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
    document.dispatchEvent(new CustomEvent('ssw:favourites-updated', { detail: { items } }));
  }

  function isFavourite(productId) {
    return getFavourites().some((item) => String(item.id) === String(productId));
  }

  function formatMoney(cents) {
    const format = window.favouritesStrings?.moneyFormat || '${{amount}}';
    const value = Number(cents) / 100;
    const amount = value.toFixed(2);
    const amountNoDecimals = String(Math.round(value));
    const [whole, fraction = '00'] = amount.split('.');
    const amountWithCommaSeparator = `${whole.replace(/\B(?=(\d{3})+(?!\d))/g, '.')},${fraction}`;
    const amountNoDecimalsWithCommaSeparator = amountNoDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    const amountWithApostropheSeparator = amount.replace(/\B(?=(\d{3})+(?!\d))/g, "'");
    const amountWithSpaceSeparator = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

    return format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, amountWithCommaSeparator)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, amountNoDecimalsWithCommaSeparator)
      .replace(/\{\{\s*amount_with_apostrophe_separator\s*\}\}/g, amountWithApostropheSeparator)
      .replace(/\{\{\s*amount_with_space_separator\s*\}\}/g, amountWithSpaceSeparator)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, amountNoDecimals)
      .replace(/\{\{\s*amount\s*\}\}/g, amount);
  }

  function escapeHtml(value) {
    return String(value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function getItemCountLabel(count) {
    const strings = window.favouritesStrings || {};
    const template = count === 1 ? strings.itemCountOne : strings.itemCountOther;
    if (!template) return count === 1 ? `${count} item saved` : `${count} items saved`;
    return template.replace('[count]', count);
  }

  function updateItemCountLabels() {
    const count = getFavourites().length;
    const label = getItemCountLabel(count);
    document.querySelectorAll('[data-favourites-item-count]').forEach((element) => {
      element.textContent = count > 0 ? label : '';
    });
  }

  function getProductDataFromButton(button) {
    return {
      id: button.dataset.productId,
      handle: button.dataset.productHandle,
      title: button.dataset.productTitle,
      url: button.dataset.productUrl,
      image: button.dataset.productImage,
      price: Number(button.dataset.productPrice || 0),
      compareAtPrice: Number(button.dataset.productComparePrice || 0),
      available: button.dataset.productAvailable === 'true',
      addedAt: Date.now(),
    };
  }

  function toggleFavourite(button) {
    const product = getProductDataFromButton(button);
    const strings = window.favouritesStrings || {};
    let items = getFavourites();
    const exists = items.some((item) => String(item.id) === String(product.id));

    if (exists) {
      items = items.filter((item) => String(item.id) !== String(product.id));
    } else {
      items.unshift(product);
    }

    saveFavourites(items);
    syncButtonState(button, !exists);
    updateHeaderCount();
    showToast(exists ? strings.removed || 'Removed from favourites' : strings.added || 'Added to favourites');
  }

  function syncButtonState(button, active) {
    const isActive = typeof active === 'boolean' ? active : isFavourite(button.dataset.productId);
    const strings = window.favouritesStrings || {};
    button.classList.toggle('is-active', isActive);
    button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
    button.setAttribute(
      'aria-label',
      isActive ? strings.remove || 'Remove from favourites' : strings.add || 'Add to favourites'
    );
  }

  function syncAllButtons() {
    document.querySelectorAll('.ssw-favorite-btn').forEach((button) => syncButtonState(button));
    updateHeaderCount();
  }

  function updateHeaderCount() {
    const count = getFavourites().length;
    document.querySelectorAll('[data-favourites-count-bubble]').forEach((bubble) => {
      const countEl = bubble.querySelector('[data-favourites-count]');
      if (countEl) countEl.textContent = count < 100 ? count : '99+';
      bubble.classList.toggle('hidden', count === 0);
      bubble.setAttribute('aria-hidden', count === 0 ? 'true' : 'false');
    });
    updateItemCountLabels();
  }

  function showToast(message) {
    if (!message) return;

    let toast = document.querySelector('.ssw-favourites-toast');
    if (!toast) {
      toast = document.createElement('div');
      toast.className = 'ssw-favourites-toast';
      toast.setAttribute('role', 'status');
      toast.setAttribute('aria-live', 'polite');
      document.body.appendChild(toast);
    }

    toast.textContent = message;
    toast.classList.add('is-visible');

    window.clearTimeout(showToast._timer);
    showToast._timer = window.setTimeout(() => {
      toast.classList.remove('is-visible');
    }, 2600);
  }

  function bindButtons(root = document) {
    root.querySelectorAll('.ssw-favorite-btn:not([data-favourites-bound])').forEach((button) => {
      button.dataset.favouritesBound = 'true';
      syncButtonState(button);

      const handleToggle = (event) => {
        event.preventDefault();
        event.stopPropagation();
        if (typeof event.stopImmediatePropagation === 'function') {
          event.stopImmediatePropagation();
        }
        toggleFavourite(button);
      };

      button.addEventListener('click', handleToggle, true);
      button.addEventListener('mousedown', (event) => event.stopPropagation(), true);
      button.addEventListener('touchstart', (event) => event.stopPropagation(), { capture: true, passive: true });
    });
  }

  function openFavouritesPanel() {
    const panel = document.getElementById('ssw-favourites-panel');
    if (!panel) return;
    panel.classList.remove('hidden');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('overflow-hidden');
    window.requestAnimationFrame(() => {
      panel.classList.add('is-open');
    });
    renderFavouritesPage();
  }

  function closeFavouritesPanel() {
    const panel = document.getElementById('ssw-favourites-panel');
    if (!panel) return;
    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('overflow-hidden');
    window.setTimeout(() => {
      if (!panel.classList.contains('is-open')) {
        panel.classList.add('hidden');
      }
    }, 320);
  }

  function bindFavouritesPanel() {
    document.querySelectorAll('[data-ssw-favourites-open]').forEach((trigger) => {
      trigger.addEventListener('click', (event) => {
        event.preventDefault();
        openFavouritesPanel();
      });
    });

    document.querySelectorAll('[data-ssw-favourites-close]').forEach((trigger) => {
      trigger.addEventListener('click', closeFavouritesPanel);
    });
  }

  async function fetchProduct(handle) {
    const response = await fetch(`${window.shopUrl}/products/${handle}.js`);
    if (!response.ok) throw new Error('Product not found');
    return response.json();
  }

  function imageWithWidth(image, width) {
    if (!image) return '';
    return image.includes('?') ? `${image}&width=${width}` : `${image}?width=${width}`;
  }

  function buildLoadingSpinner() {
    return `<span class="loading__spinner hidden" aria-hidden="true">
      <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
      </svg>
    </span>`;
  }

  function getSizeOptionKey(product) {
    const options = product.options || [];
    const sizeIndex = options.findIndex((name) => /size/i.test(String(name)));
    if (sizeIndex >= 0) return `option${sizeIndex + 1}`;
    if (options.length === 1) return 'option1';
    return 'option1';
  }

  function getSizeChoices(product) {
    const optionKey = getSizeOptionKey(product);
    const choices = new Map();

    (product.variants || []).forEach((variant) => {
      const label = variant[optionKey];
      if (!label) return;

      const existing = choices.get(label);
      if (!existing) {
        choices.set(label, {
          label,
          variantId: variant.id,
          available: Boolean(variant.available),
        });
        return;
      }

      if (variant.available && !existing.available) {
        choices.set(label, {
          label,
          variantId: variant.id,
          available: true,
        });
      }
    });

    return Array.from(choices.values());
  }

  function buildSizePickerHtml(product) {
    const strings = window.favouritesStrings || {};
    const sizes = getSizeChoices(product);
    const sizeLabel = (product.options || []).find((name) => /size/i.test(String(name))) || strings.sizeLabel || 'Size';

    const sizeButtons = sizes
      .map((size) => {
        const disabled = size.available ? '' : ' disabled aria-disabled="true"';
        const className = size.available
          ? 'ssw-favourites-card__size'
          : 'ssw-favourites-card__size ssw-favourites-card__size--soldout';
        return `<button
          type="button"
          class="${className}"
          data-ssw-favourites-atc
          data-variant-id="${size.variantId}"
          aria-label="${escapeHtml(sizeLabel)} ${escapeHtml(size.label)}"
          ${disabled}
        >${escapeHtml(size.label)}</button>`;
      })
      .join('');

    return `
      <div class="ssw-favourites-card__options" data-ssw-favourites-options data-product-id="${product.id}">
        <button
          type="button"
          class="ssw-favourites-card__atc button button--primary"
          data-ssw-favourites-choose-options
          aria-expanded="false"
          aria-controls="ssw-fav-sizes-${product.id}"
        >
          ${strings.chooseOptions || 'Choose options'}
        </button>
        <div
          id="ssw-fav-sizes-${product.id}"
          class="ssw-favourites-card__sizes hidden"
          data-ssw-favourites-sizes
          hidden
        >
          <p class="ssw-favourites-card__sizes-label">${escapeHtml(sizeLabel)}</p>
          <div class="ssw-favourites-card__sizes-grid" role="list">${sizeButtons}</div>
        </div>
      </div>
    `;
  }

  function buildCartActionHtml(product) {
    const strings = window.favouritesStrings || {};
    const spinner = buildLoadingSpinner();

    if (!product.available) {
      return `<span class="ssw-favourites-card__soldout">${strings.soldOut || 'Sold out'}</span>`;
    }

    const variants = product.variants || [];

    if (variants.length === 1) {
      const variant = variants[0];
      if (!variant.available) {
        return `<span class="ssw-favourites-card__soldout">${strings.soldOut || 'Sold out'}</span>`;
      }

      return `<button
        type="button"
        class="ssw-favourites-card__atc button button--primary"
        data-ssw-favourites-atc
        data-variant-id="${variant.id}"
      ><span>${strings.addToCart || 'Add to cart'}</span>${spinner}</button>`;
    }

    return buildSizePickerHtml(product);
  }

  async function handleAddToCart(button) {
    const variantId = button.dataset.variantId;
    if (!variantId || button.getAttribute('aria-disabled') === 'true') return;

    const strings = window.favouritesStrings || {};
    const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    const spinner = button.querySelector('.loading__spinner');
    const label = button.querySelector('span');
    const sizeLabel = button.classList.contains('ssw-favourites-card__size') ? button.textContent.trim() : '';

    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');
    if (label) label.textContent = strings.adding || 'Adding...';

    const config = typeof fetchConfig === 'function' ? fetchConfig('javascript') : { method: 'POST' };
    config.headers = config.headers || {};
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    delete config.headers['Content-Type'];

    const formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', 1);

    if (cart && typeof cart.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cart.getSectionsToRender().map((section) => section.id)
      );
      formData.append('sections_url', window.location.pathname);
      cart.setActiveElement(button);
    }

    config.body = formData;

    try {
      const response = await fetch(window.routes.cart_add_url, config);
      const data = await response.json();

      if (data.status) {
        showToast(data.description || strings.soldOut || 'Sold out');
        return;
      }

      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, {
          source: 'ssw-favourites',
          productVariantId: variantId,
          cartData: data,
        });
      }

      if (cart && typeof cart.renderContents === 'function') {
        closeFavouritesPanel();
        cart.renderContents(data);
      } else {
        window.location = window.routes.cart_url;
        return;
      }

      showToast(strings.addedToCart || 'Added to cart');
    } catch (error) {
      showToast(window.cartStrings?.error || 'Could not add to cart');
    } finally {
      button.removeAttribute('aria-disabled');
      button.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
      if (label) label.textContent = strings.addToCart || 'Add to cart';
      else if (sizeLabel) button.textContent = sizeLabel;
    }
  }

  function bindChooseOptionsButtons(root = document) {
    root.querySelectorAll('[data-ssw-favourites-choose-options]:not([data-ssw-favourites-choose-bound])').forEach((button) => {
      button.dataset.sswFavouritesChooseBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();

        const optionsWrap = button.closest('[data-ssw-favourites-options]');
        const sizesPanel = optionsWrap?.querySelector('[data-ssw-favourites-sizes]');
        if (!sizesPanel) return;

        const willOpen = sizesPanel.classList.contains('hidden');

        root.querySelectorAll('[data-ssw-favourites-sizes]').forEach((panel) => {
          panel.classList.add('hidden');
          panel.hidden = true;
        });
        root.querySelectorAll('[data-ssw-favourites-choose-options]').forEach((trigger) => {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.closest('.ssw-favourites-card')?.classList.remove('ssw-favourites-card--sizes-open');
        });

        if (willOpen) {
          sizesPanel.classList.remove('hidden');
          sizesPanel.hidden = false;
          button.setAttribute('aria-expanded', 'true');
          button.closest('.ssw-favourites-card')?.classList.add('ssw-favourites-card--sizes-open');
        }
      });
    });
  }

  function closeSizePanels(root = document) {
    root.querySelectorAll('[data-ssw-favourites-sizes]').forEach((panel) => {
      panel.classList.add('hidden');
      panel.hidden = true;
    });
    root.querySelectorAll('[data-ssw-favourites-choose-options]').forEach((trigger) => {
      trigger.setAttribute('aria-expanded', 'false');
      trigger.closest('.ssw-favourites-card')?.classList.remove('ssw-favourites-card--sizes-open');
    });
  }

  function bindAddToCartButtons(root = document) {
    root.querySelectorAll('[data-ssw-favourites-atc]:not([data-ssw-favourites-atc-bound])').forEach((button) => {
      button.dataset.sswFavouritesAtcBound = 'true';
      button.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        handleAddToCart(button);
      });
    });
  }

  function buildFavouriteCard(product, layout) {
    const strings = window.favouritesStrings || {};
    const image = product.featured_image || product.images?.[0];
    const imageSrc = imageWithWidth(image, layout === 'panel' ? 240 : 533);
    const title = escapeHtml(product.title);
    const priceHtml =
      product.compare_at_price && product.compare_at_price > product.price
        ? `<span class="ssw-favourites-card__price ssw-favourites-card__price--sale">${formatMoney(product.price)}</span>
           <s class="ssw-favourites-card__compare">${formatMoney(product.compare_at_price)}</s>`
        : `<span class="ssw-favourites-card__price">${formatMoney(product.price)}</span>`;

    const heartSvg = `<svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" class="icon icon-heart" viewBox="0 0 20 20" fill="none">
      <path class="icon-heart__outline" fill-rule="evenodd" clip-rule="evenodd" d="M10 5.2393L8.5149 3.77392C6.79996 2.08174 4.01945 2.08174 2.30451 3.77392C0.589562 5.4661 0.589563 8.2097 2.30451 9.90188L10 17.4952L17.6955 9.90188C19.4104 8.2097 19.4104 5.4661 17.6955 3.77392C15.9805 2.08174 13.2 2.08174 11.4851 3.77392L10 5.2393ZM10.765 3.06343C12.8777 0.978857 16.3029 0.978856 18.4155 3.06343C20.5282 5.148 20.5282 8.52779 18.4155 10.6124L10.72 18.2057C10.3224 18.5981 9.67763 18.5981 9.27996 18.2057L1.58446 10.6124C-0.528154 8.52779 -0.528154 5.14801 1.58446 3.06343C3.69708 0.978859 7.12233 0.978858 9.23495 3.06343L10 3.81832L10.765 3.06343Z" fill="currentColor"></path>
      <path class="icon-heart__filled" d="M10 17.4952L2.30451 9.90188C0.589563 8.2097 0.589562 5.4661 2.30451 3.77392C4.01945 2.08174 6.79996 2.08174 8.5149 3.77392L10 5.2393L11.4851 3.77392C13.2 2.08174 15.9805 2.08174 17.6955 3.77392C19.4104 5.4661 19.4104 8.2097 17.6955 9.90188L10 17.4952Z" fill="currentColor"></path>
    </svg>`;

    const removeButton = `<button
      type="button"
      class="ssw-favorite-btn ssw-favorite-btn--compact is-active"
      data-product-id="${product.id}"
      data-product-handle="${escapeHtml(product.handle)}"
      data-product-title="${title}"
      data-product-url="${product.url}"
      data-product-image="${image || ''}"
      data-product-price="${product.price}"
      data-product-compare-price="${product.compare_at_price || 0}"
      data-product-available="${product.available}"
      aria-label="${strings.remove || 'Remove from favourites'}"
      aria-pressed="true"
    >${heartSvg}</button>`;

    const actionsHtml = buildCartActionHtml(product);

    if (layout === 'panel') {
      return `
        <li class="ssw-favourites-item">
          <article class="ssw-favourites-card ssw-favourites-card--panel">
            <a href="${product.url}" class="ssw-favourites-card__media">
              ${imageSrc ? `<img src="${imageSrc}" alt="${title}" loading="lazy" width="120" height="160">` : ''}
            </a>
            <div class="ssw-favourites-card__info">
              <h3 class="ssw-favourites-card__title">
                <a href="${product.url}">${title}</a>
              </h3>
              <div class="ssw-favourites-card__prices">${priceHtml}</div>
              <div class="ssw-favourites-card__actions">${actionsHtml}</div>
            </div>
            ${removeButton}
          </article>
        </li>
      `;
    }

    return `
      <li class="grid__item">
        <article class="ssw-favourites-card ssw-favourites-card--grid">
          <div class="ssw-favourites-card__media">
            <a href="${product.url}" class="ssw-favourites-card__link">
              ${imageSrc ? `<img src="${imageSrc}" alt="${title}" loading="lazy" width="533" height="533">` : ''}
            </a>
            ${removeButton}
          </div>
          <div class="ssw-favourites-card__info">
            <h3 class="ssw-favourites-card__title">
              <a href="${product.url}">${title}</a>
            </h3>
            <div class="ssw-favourites-card__prices">${priceHtml}</div>
            <div class="ssw-favourites-card__actions">${actionsHtml}</div>
          </div>
        </article>
      </li>
    `;
  }

  async function renderFavouritesPage() {
    const sections = document.querySelectorAll('[data-ssw-favourites-section]');
    if (!sections.length) return;

    const items = getFavourites();

    for (const section of sections) {
      const grid = section.querySelector('[data-ssw-favourites-grid]');
      const empty = section.querySelector('[data-ssw-favourites-empty]');
      const loading = section.querySelector('[data-ssw-favourites-loading]');

      if (!grid || !empty) continue;

      if (items.length === 0) {
        if (loading) loading.classList.add('hidden');
        grid.innerHTML = '';
        empty.classList.remove('hidden');
        continue;
      }

      empty.classList.add('hidden');
      if (loading) loading.classList.remove('hidden');
    }

    const sectionId = sections[0].dataset.sectionId || 'favourites';
    const results = await Promise.all(
      items.map(async (item) => {
        try {
          return await fetchProduct(item.handle);
        } catch (error) {
          return null;
        }
      })
    );

    const validProducts = results.filter(Boolean);
    const validHandles = new Set(validProducts.map((product) => product.handle));
    const cleanedItems = items.filter((item) => validHandles.has(item.handle));

    if (cleanedItems.length !== items.length) {
      saveFavourites(cleanedItems);
    }

    sections.forEach((section) => {
      const grid = section.querySelector('[data-ssw-favourites-grid]');
      const empty = section.querySelector('[data-ssw-favourites-empty]');
      const loading = section.querySelector('[data-ssw-favourites-loading]');

      if (!grid || !empty) return;

      if (loading) loading.classList.add('hidden');

      if (validProducts.length === 0) {
        grid.innerHTML = '';
        empty.classList.remove('hidden');
        return;
      }

      empty.classList.add('hidden');
      const layout = section.closest('#ssw-favourites-panel') ? 'panel' : 'grid';
      grid.innerHTML = validProducts.map((product) => buildFavouriteCard(product, layout)).join('');
      bindButtons(grid);
      bindAddToCartButtons(grid);
      bindChooseOptionsButtons(grid);
    });
  }

  function init() {
    bindButtons();
    bindFavouritesPanel();
    updateHeaderCount();
    renderFavouritesPage();

    document.addEventListener('ssw:favourites-updated', () => {
      syncAllButtons();
      renderFavouritesPage();
    });

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
        if (event.source === 'ssw-favourites') return;
        const panel = document.getElementById('ssw-favourites-panel');
        if (!panel?.classList.contains('is-open')) return;
        closeSizePanels(panel);
      });
    }

    document.addEventListener('shopify:section:load', (event) => {
      bindButtons(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
